/* ============================================================
   THE VAPE GUYS — variant image switching + tap-to-Quick-View cards
   Works on every screen size (phone, tablet, desktop) and in:
     1. Product page gallery
     2. Quick View popup
     3. Product cards (inline flavour/colour picker)
     4. Whole product card opens Quick View (see section 4)
   Loaded after theme.js. It never touches cart logic: it only moves
   the gallery by "clicking" the theme's own thumbs/dots, so theme.js
   stays in sync (swipe, arrows, etc.).
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function norm(s) { return String(s || '').toLowerCase().replace(/%20/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim(); }

  function readVariants(root) {
    var el = $('[data-variants]', root);
    if (!el) return [];
    if (!el._parsed) { try { el._parsed = JSON.parse(el.textContent); } catch (e) { el._parsed = []; } }
    return el._parsed;
  }

  /* ---------- gallery helpers ---------- */
  function goTo(gallery, n) {
    var slides = $$('[data-slide]', gallery);
    if (n < 0 || n >= slides.length) return false;
    if (slides[n].classList.contains('is-active')) return true;
    // Use the theme's own controls so its internal index (swipe) stays correct
    var ctrl = $('[data-thumb="' + n + '"]', gallery) || $('[data-dot="' + n + '"]', gallery);
    if (ctrl) ctrl.click();
    else if (gallery._show) gallery._show(n);
    else { slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); }); }
    centreThumb(gallery, n);
    return true;
  }
  // Thumb strip scrolls sideways on phones/tablets: centre the active thumb without moving the page
  function centreThumb(gallery, n) {
    var strip = $('.gallery__thumbs', gallery), t = $('[data-thumb="' + n + '"]', gallery);
    if (!strip || !t || strip.scrollWidth <= strip.clientWidth) return;
    var left = Math.max(0, t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2);
    try { strip.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { strip.scrollLeft = left; }
  }
  function indexOfMedia(gallery, id) {
    var slides = $$('[data-slide]', gallery);
    for (var n = 0; n < slides.length; n++) { if (String(slides[n].getAttribute('data-media-id')) === String(id)) return n; }
    return -1;
  }
  // Fallback when a variant has no image linked in Shopify admin:
  // match the option value ("Sour Pineapple Ice", "Black Carbon") to image alt text / file name.
  function indexOfValue(gallery, value) {
    var k = norm(value);
    if (k.length < 3) return -1;
    var slides = $$('[data-slide]', gallery), hits = [];
    slides.forEach(function (s, n) {
      var img = $('img', s); if (!img) return;
      var file = (img.getAttribute('src') || '').split('?')[0].split('/').pop();
      if ((' ' + norm((img.getAttribute('alt') || '') + ' ' + file) + ' ').indexOf(' ' + k + ' ') > -1) hits.push(n);
    });
    // a word on every image (usually from the product title, e.g. "30mg") identifies nothing
    if (!hits.length || hits.length === slides.length) return -1;
    var active = slides.findIndex ? slides.findIndex(function (s) { return s.classList.contains('is-active'); }) : -1;
    return hits.indexOf(active) > -1 ? active : hits[0];
  }

  /* ---------- 1 + 2: product page & quick view ---------- */
  function syncRoot(root, changedIndex) {
    var gallery = $('[data-gallery]', root);
    var variants = readVariants(root);
    if (variants.length < 2) return;
    var sets = $$('fieldset[data-option-index]', root);
    var sel = sets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    if (!sel.some(function (s) { return s != null; })) return;

    // First variant that matches everything chosen so far AND has an image.
    // So picking only the flavour (before strength) already shows the flavour photo.
    var hit = null;
    for (var i = 0; i < variants.length && !hit; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) { if (sel[j] != null && v.options[j] !== sel[j]) { ok = false; break; } }
      if (ok && v.media) hit = v;
    }

    var shown = false, n = -1;
    if (gallery) {
      if (hit) n = indexOfMedia(gallery, hit.media);
      if (n < 0) {
        var order = [changedIndex];
        for (var k = 0; k < sel.length; k++) { if (k !== changedIndex) order.push(k); }
        for (var o = 0; o < order.length && n < 0; o++) { if (sel[order[o]] != null) n = indexOfValue(gallery, sel[order[o]]); }
      }
      if (n > -1) shown = goTo(gallery, n);
      // No photo exists for this choice: go back to the main image rather than
      // leaving the previous flavour/colour on screen (that would mislead the shopper)
      else goTo(gallery, 0);
    }

    // Mini preview next to the option name (visible on phones only, see product-options.liquid)
    var src = hit && hit.img ? hit.img : '';
    if (!src && shown && gallery) { var a = $('[data-slide].is-active img', gallery); if (a) src = a.currentSrc || a.src; }
    $$('[data-option-thumb]', root).forEach(function (im, idx) {
      if (src && idx === changedIndex) { if (im.getAttribute('src') !== src) im.setAttribute('src', src); im.hidden = false; }
      else im.hidden = true;
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var fs = t.closest('fieldset[data-option-index]');
    var root = fs && fs.closest('[data-product-root]');
    if (!root) return;
    var idx = Number(fs.getAttribute('data-option-index')) || 0;
    // run after theme.js has handled the same change (price, button, URL)
    setTimeout(function () { syncRoot(root, idx); }, 0);
  });

  /* ---------- 3: product cards ---------- */
  function setCardImage(card, opt) {
    var img = card && $('.pcard__img--primary', card);
    if (!img) return;
    var second = $('.pcard__img--second', card);
    if (!img.hasAttribute('data-orig-src')) {
      img.setAttribute('data-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
    }
    var src = opt ? opt.getAttribute('data-variant-image') : '';
    if (src) {
      var ss = opt.getAttribute('data-variant-srcset');
      if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      card.classList.add('has-variant-img');
      if (second) second.style.opacity = '0'; // keep the picked photo; no hover swap
    } else {
      var os = img.getAttribute('data-orig-srcset');
      if (os) img.setAttribute('srcset', os); else img.removeAttribute('srcset');
      img.setAttribute('src', img.getAttribute('data-orig-src'));
      card.classList.remove('has-variant-img');
      if (second) second.style.opacity = '';
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opt = t.closest('[data-picker-option]');
    if (opt && !opt.disabled) { setCardImage(opt.closest('[data-product-card]'), opt); return; }
    var card = t.closest('[data-product-card]');
    if (!card || !card.classList.contains('has-variant-img')) return;
    // picker closed (Cancel / Close button)? put the original photo back
    setTimeout(function () { var p = $('[data-picker]', card); if (!p || p.hidden) setCardImage(card, null); }, 0);
  });

  /* ============================================================
     4. Whole product card opens Quick View (phone, tablet, desktop)
     - Tap/click anywhere on the card (image, title, price, empty space)
       AND its Add to Cart / Select options button opens the popup, so the
       shopper picks flavour, strength and quantity there. Only the
       wishlist heart and the eye icon keep their own job.
     - Only INTENTIONAL taps count: a finger that moved (scroll/swipe),
       a long press, a tap that stops a fling, or any scroll in between
       is ignored, so scrolling a grid or a product slider never pops it.
     - Ctrl/Cmd/Shift/middle-click still open the product page in a new
       tab, and the links stay real links for Google.
     - Speed: the popup HTML starts downloading the moment a finger lands
       (or the mouse rests on a card), so it is usually ready on release.
     - Phone back button closes the popup instead of leaving the page.
     ============================================================ */
  var MOVE_PX = 10, LONG_PRESS_MS = 600, FLING_MS = 150;
  var down = null, lastScroll = 0;

  // Card controls that must keep working on their own. The card's Add to Cart /
  // Select options button ([data-card-add]) is NOT one of them: it opens the popup.
  var CONTROL = 'button, input, select, textarea, label, [data-picker], [data-wishlist-toggle], [data-quick-view], [data-picker-option]';
  function isControl(t) { return !!t.closest(CONTROL) && !t.closest('[data-card-add]'); }

  // remember when anything scrolled (page, grids, horizontal product rows)
  document.addEventListener('scroll', function () { lastScroll = Date.now(); }, { capture: true, passive: true });

  function scrollState(el) {
    var s = [window.pageXOffset, window.pageYOffset];
    for (var n = el; n && n !== document.body; n = n.parentElement) { s.push(n.scrollLeft, n.scrollTop); }
    return s.join(',');
  }

  /* ---- prefetch: answer the theme's own quick-view fetch from memory ---- */
  var qvPrefetch = {};
  function qvUrl(handle) { return (window.theme && window.theme.routes && window.theme.routes.root || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '?view=quickview'; }
  function prefetch(handle) {
    if (!handle || qvPrefetch[handle]) return;
    var nativeFetch = window.__tvgFetch || window.fetch;
    qvPrefetch[handle] = nativeFetch.call(window, qvUrl(handle), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('qv'); return r.text(); })
      .catch(function () { delete qvPrefetch[handle]; return null; });
  }
  if (window.fetch && !window.__tvgFetch) {
    window.__tvgFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var m = url.indexOf('view=quickview') > -1 && url.match(/\/products\/([^/?#]+)/);
      if (m) {
        var h = decodeURIComponent(m[1]);
        if (qvPrefetch[h]) {
          return qvPrefetch[h].then(function (txt) {
            if (txt == null) return window.__tvgFetch.call(window, input, init);
            return new Response(txt, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
          });
        }
      }
      return window.__tvgFetch.apply(window, arguments);
    };
  }

  function cardOf(t) { return t && t.closest ? t.closest('[data-product-card]') : null; }

  document.addEventListener('pointerdown', function (e) {
    var card = cardOf(e.target);
    if (!card || (e.pointerType === 'mouse' && e.button !== 0)) { down = null; return; }
    down = {
      card: card, x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId,
      moved: false, scroll: scrollState(card),
      // finger landed to stop a moving list (touch only: a mouse click right after
      // using the scroll wheel is a normal, intentional click)
      afterFling: e.pointerType !== 'mouse' && Date.now() - lastScroll < FLING_MS
    };
    if (!isControl(e.target)) prefetch(card.getAttribute('data-product-handle'));
  }, { passive: true, capture: true });

  document.addEventListener('pointermove', function (e) {
    if (!down || e.pointerId !== down.id || down.moved) return;
    if (Math.abs(e.clientX - down.x) > MOVE_PX || Math.abs(e.clientY - down.y) > MOVE_PX) down.moved = true;
  }, { passive: true, capture: true });
  // the browser took over the gesture as a scroll/swipe
  document.addEventListener('pointercancel', function () { if (down) down.moved = true; }, { passive: true, capture: true });

  // Desktop: warm the popup when the mouse rests on a card
  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    var card = cardOf(e.target);
    if (!card || card._qvWarm) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { card._qvWarm = true; prefetch(card.getAttribute('data-product-handle')); }, 120);
  }, { passive: true });

  function intentional(card) {
    if (!down || down.card !== card) return true; // keyboard (Enter) or assistive tech: always intentional
    var ok = !down.moved && !down.afterFling &&
      Date.now() - down.t < LONG_PRESS_MS &&
      scrollState(card) === down.scroll;
    down = null;
    return ok;
  }

  document.addEventListener('click', function (e) {
    var card = cardOf(e.target);
    if (!card || e.defaultPrevented) return;
    if (isControl(e.target)) { down = null; return; }      // wishlist / eye icon do their own thing
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return; // new tab / window
    var qvBtn = $('[data-quick-view]', card);
    if (!qvBtn) return; // Quick View switched off in theme settings: links work as before
    e.preventDefault();
    e.stopPropagation();
    if (!intentional(card)) return;
    qvBtn.click(); // the theme's own Quick View (cart, variants, add to cart all unchanged)
  }, true);

  /* ---- phone back button closes the popup ---- */
  var qvOverlay = null, pushed = false;
  function watchOverlay() {
    qvOverlay = $('[data-overlay="quickview"]');
    if (!qvOverlay || !window.MutationObserver || !window.history.pushState) return;
    new MutationObserver(function () {
      if (!qvOverlay.hidden && !pushed) {
        pushed = true;
        history.pushState({ tvgQv: true }, '', window.location.href);
      } else if (qvOverlay.hidden && pushed) {
        pushed = false;
        if (history.state && history.state.tvgQv) history.back();
      }
    }).observe(qvOverlay, { attributes: true, attributeFilter: ['hidden'] });
  }
  // A link clicked inside the popup ("View full details", brand): drop the popup's
  // history step first, so Back from the product page returns to the list in one press.
  var pendingNav = null;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !pushed || !qvOverlay || qvOverlay.hidden || !qvOverlay.contains(a)) return;
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || a.target === '_blank') return;
    e.preventDefault();
    pendingNav = a.href;
    pushed = false;
    history.back();
  });
  window.addEventListener('popstate', function () {
    if (pendingNav) { var u = pendingNav; pendingNav = null; window.location.href = u; return; }
    if (pushed && qvOverlay && !qvOverlay.hidden) {
      pushed = false;
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    }
  });

  /* ---- feel: pointer cursor, no grey tap flash, no double-tap zoom delay ---- */
  var st = document.createElement('style');
  st.textContent =
    '[data-product-card]{cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation}' +
    '[data-product-card] .pcard__media{-webkit-touch-callout:none}';
  document.head.appendChild(st);

  /* ---- single-product card button reads "Quick Add" ----
     theme.js rewrites that label after every cart change ("Add to Cart" /
     "Add More (n)"); put "Quick Add" back whenever it does. */
  var QUICK = 'Quick Add';
  function quickLabel(node) {
    if (node.nodeType !== 3 || !node.parentElement) return;
    if (!node.parentElement.closest('[data-card-add][data-mode="add"] [data-atc-label]')) return;
    if (node.nodeValue.trim() && node.nodeValue.trim() !== QUICK) node.nodeValue = ' ' + QUICK;
  }
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { if (list[i].type === 'characterData') quickLabel(list[i].target); }
    }).observe(document.documentElement, { subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchOverlay);
  else watchOverlay();
})();
